<template>
    <div></div>
  </template>
  
  <script>
  export default {
      name: 'IndexView',
      mounted(){
          this.$router.push('/login')
      }
  }
  </script>
  
  <style>
  
  </style>